import root from 'window-or-global';
import {loadingSpinner} from './loadingSpinner';

// these can all be changed by calling the set method below
let purchaseContainer = 'webPurchaseContainer';
let purchaseContainerCloseBtn = `${purchaseContainer}_closeBtn`;
let purchaseContainerLoader = `${purchaseContainer}_loading`;
let purchaseBg = 'webPurchaseBg';

export const setCustomPurchaseBgId = (id) => {
    purchaseBg = id;
};
export const setCustomPurchaseContainerId = (id) => {
    purchaseContainer = id;
    purchaseContainerCloseBtn = `${id}_closeBtn`;
    purchaseContainerLoader = `${id}_loading`;
};

const getOpenerDocument = () => {
    try {
        return (root.parent && root.parent.document) || root.document;
    } catch (e) {
        console.log(e);
    }
};

export const getWebPurchaseContainer = function getWebPurchaseContainer() {
    const openerDocument = getOpenerDocument();
    return openerDocument.getElementById(purchaseContainer);
};

export const getWebPurchaseIframe = function getWebPurchaseIframe() {
    const iframes = getWebPurchaseContainer().getElementsByTagName('iframe');
    return iframes && iframes.length ? iframes[0] : null;
};

export const getWebPurchaseCloseBtn = function getWebPurchaseCloseBtn() {
    const closeBtns = getWebPurchaseContainer().getElementsByClassName(
        `${purchaseContainer}_closeBtn`
    );
    return closeBtns && closeBtns.length ? closeBtns[0] : null;
};

export const getWebPurchaseLoading = function getWebPurchaseLoading() {
    const loading = getWebPurchaseContainer().getElementsByClassName(
        `${purchaseContainer}_loading`
    );
    return loading && loading.length ? loading[0] : null;
};

export const getWebPurchaseBackground = function getWebPurchaseBackground() {
    const openerDocument = getOpenerDocument();
    return openerDocument.getElementById(purchaseBg);
};

export const getDieselReactWrapper = function getDieselReactWrapper() {
    const openerDocument = getOpenerDocument();
    return openerDocument.getElementById('dieselReactWrapper');
};

export const loadQuickPurchase = function loadQuickPurchase() {
    const iframeEle = getWebPurchaseIframe();
    const openerDocument = getOpenerDocument();
    const loadingSection = openerDocument.createElement('section');
    loadingSection.innerHTML = loadingSpinner;
    loadingSection.classList.add('quick-purchase-loading');
    iframeEle.contentWindow.document.body.appendChild(loadingSection);
};

export const loadWebPurchaseContainer = function loadWebPurchaseContainer() {
    // Ensure only one instance is ever created
    let webPurchaseContainer = getWebPurchaseContainer();
    if (webPurchaseContainer) return webPurchaseContainer;
    const openerDocument = getOpenerDocument();
    let webPurchaseBg = getWebPurchaseBackground();
    if (!webPurchaseBg) {
        webPurchaseBg = openerDocument.createElement('div');
        webPurchaseBg.setAttribute('id', purchaseBg);
        webPurchaseBg.classList.add(purchaseBg, 'loading');
        openerDocument.body.appendChild(webPurchaseBg);
    }

    webPurchaseContainer = openerDocument.createElement('div');
    const paymentIFrame = openerDocument.createElement('iframe');
    paymentIFrame.classList.add('hidden');
    webPurchaseContainer.setAttribute('id', purchaseContainer);
    webPurchaseContainer.classList.add(purchaseContainer);
    webPurchaseContainer.appendChild(paymentIFrame);

    const closeBtn = openerDocument.createElement('span');
    closeBtn.classList.add(purchaseContainerCloseBtn);
    closeBtn.innerHTML = 'x';
    webPurchaseContainer.appendChild(closeBtn);

    const loadingSection = openerDocument.createElement('section');
    loadingSection.innerHTML = loadingSpinner;
    loadingSection.classList.add(purchaseContainerLoader);
    webPurchaseContainer.appendChild(loadingSection);

    openerDocument.body.appendChild(webPurchaseContainer);
    webPurchaseContainer.classList.remove('hidden');
    webPurchaseBg.classList.remove('hidden');
    openerDocument.body.classList.add('prevent-scroll-mobile');
    openerDocument.documentElement.classList.add('prevent-scroll-mobile');

    const dieselWrapper = getDieselReactWrapper();
    if (dieselWrapper) dieselWrapper.classList.add('prevent-scroll-mobile');
    return webPurchaseContainer;
};

export const closePurchaseContainer = function closePurchaseContainer(reason) {
    const openerDocument = getOpenerDocument();
    console.log(`WebIntegrationAPI.PurchaseFlow.RequestClose: ${reason}`);

    const webPurchaseBg = getWebPurchaseBackground();
    if (webPurchaseBg) {
        webPurchaseBg.classList.add('hidden');
        webPurchaseBg.parentNode.removeChild(webPurchaseBg);
    }

    openerDocument.body.classList.remove('prevent-scroll-mobile');
    openerDocument.documentElement.classList.remove('prevent-scroll-mobile');

    const dieselWrapper = getDieselReactWrapper();
    if (dieselWrapper) dieselWrapper.classList.remove('prevent-scroll-mobile');

    // This needs to be the last thing done since this script will stop executing
    // when the iframe containing this script is removed from the DOM
    const webPurchaseContainer = getWebPurchaseContainer();
    if (webPurchaseContainer) {
        webPurchaseContainer.classList.add('hidden');
        webPurchaseContainer.parentNode.removeChild(webPurchaseContainer);
    }
};
